import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const FormsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
